import React, { Fragment } from 'react'
import { ImageUsageSectionProps } from './ImageUsageSection.types'
import styles from './ImageUsageSection.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { IMAGE_EDITOR_STORE } from 'store'
import { Checkbox } from 'components/shared/Checkbox'
import { Button } from 'components/shared/Button'
import { DropdownSelect, HorizontalLine, Text1 } from "@touche-lts/panel-ui/dist"

const ImageUsageSectionComponent = (props: ImageUsageSectionProps) => {
  const {
    className,
    style,
    [IMAGE_EDITOR_STORE]: {
      isSelectedImageAspectCropForGeneralUse,
      onGeneralUseCheckboxClick,
      attributeGroupIds,
      getAttributeGroupSelectorProps,
      onAttributeValueClick
    }
  } = props

  const colorPreset="bright"

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <Text1 style={{ color: styles.secondaryContent }}>
        Image is used as
      </Text1>
      <Button
        preset='link'
        className={styles.checkboxButton}
        onClick={onGeneralUseCheckboxClick}
      >
        <Checkbox isChecked={isSelectedImageAspectCropForGeneralUse} />
        <Text1>General</Text1>
      </Button>
      {Boolean(attributeGroupIds?.length) && (
            <>
              <HorizontalLine colorPreset={colorPreset} />
              <Text1
                colorPreset={colorPreset}
                className={cl(
                  styles.usageTextLabel,
                  styles[colorPreset + 'UsageTextLabel']
                )}
                style={{ marginTop: 18 }}
              >
                Image is related to:
              </Text1>
              <div
                className={styles.scrollable}
                style={{ height: 500, maxHeight: 500 }}
              >
                {attributeGroupIds.map(attributeGroupId => {
                  const selectorProps = getAttributeGroupSelectorProps(
                    attributeGroupId
                  )
                  return (
                    <Fragment key={attributeGroupId}>
                      <Text1
                        bold
                        overflowEllipsis
                        colorPreset={colorPreset}
                        className={styles.groupLabelText}
                      >
                        {selectorProps.groupLabel}
                      </Text1>
                      <DropdownSelect
                        colorPreset={colorPreset}
                        options={selectorProps.selectOptions}
                        onOptionClick={onAttributeValueClick}
                      />
                    </Fragment>
                  )
                })}
              </div>
            </>
          )}
    </div>
  )
}

const ImageUsageSection = inject(
  'IMAGE_EDITOR_STORE'
)(observer(ImageUsageSectionComponent))
export { ImageUsageSection }
